import Reveal from '@/components/base/Reveal';
import SectionLabel from '@/components/base/SectionLabel';
import { menswearItems } from '../data';

export default function Menswear() {
  return (
    <section id="menswear" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-xl">
            <SectionLabel>Men&rsquo;s Traditional Wear</SectionLabel>
            <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-foreground-950">
              The Art of Traditional Menswear
            </h2>
          </div>
          <p className="max-w-md text-[15px] leading-relaxed text-foreground-700">
            From classic veshtis and dhotis to traditional shirts and coordinated sets,
            discover timeless South Indian menswear for weddings, festivals and celebrations.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {menswearItems.map((item, i) => (
            <Reveal key={item.title} delay={i * 90}>
              <article className="group">
                <div className="img-zoom rounded-lg overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} — traditional South Indian menswear from SRM Textiles`}
                    className="h-80 w-full object-cover object-top"
                  />
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <h3 className="font-heading text-2xl font-semibold text-foreground-950">{item.title}</h3>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-primary-600 transition-all group-hover:bg-accent-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
                  </span>
                </div>
                <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{item.description}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-500"
          >
            Explore Men&rsquo;s Collection
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}